/* globals _ */

import Collection from '../framework/collections/base';

import Clock from '../framework/views/clock';
import Calendar from '../framework/views/calendar';

import PredictionSet from '../framework/collection-views/prediction-set';

import getLocation from '../service/location';
import getPredictions from '../service/autocomplete';
import geocoder from '../service/geocode';

const { debounce, find } = _;

export default function( $, { model: session } ) {
	var $body = $( 'body' );

	var clientLocation = null;

	var $editors = $( '.-editor' );

	// =========================
	// ! Location Autocomplete
	// =========================

	var autocomplete = debounce( getPredictions, 300 );

	$( '.place-autocomplete' ).each( function() {
		var $this = $( this ),
			$form = $this.parents( 'form' ),
			$search = $this.find( '.-search' ),
			$result = $this.find( '.-result' ),
			$geocode = $this.find( '.-geocode' ),
			$list = $this.find( '.-predictions' );

		var predictions = new PredictionSet( {
			el: $list,
			collection: new Collection(),
			childOptions: {
				className: 'dropdown-item',
			},
		} );

		predictions.render().$el.hide();

		predictions.on( 'child:select', prediction => {
			$search.val( prediction.model.get( 'label' ) );
			$result.val( prediction.model.id ).trigger( 'input' );
			predictions.$el.hide();

			if ( $form.hasClass( '-autosubmit' ) ) {
				$form.trigger( 'submit' );
			}
		} );

		var lastQuery = '';
		$search.on( 'input', function() {
			var query = this.value || '';

			if ( query.length < 3 || query === lastQuery ) {
				if ( query.length < 3 ) {
					$geocode.show();
					predictions.collection.reset( [] );
					predictions.$el.hide();
				}
				return;
			}

			lastQuery = query;

			autocomplete( query, items => {
				predictions.collection.reset( items.map( item => ( {
					id: item.place_id,
					label: item.description,
				} ) ) );
				predictions.$el.show();
			} );

			$geocode.hide();
		} );

		$geocode.click( function() {
			if ( clientLocation ) {
				$search.val( clientLocation.formatted_address );
				$result.val( clientLocation.place_id ).trigger( 'input' );

				if ( $form.hasClass( '-autosubmit' ) ) {
					$form.trigger( 'submit' );
				}

				return;
			}

			navigator.geolocation.getCurrentPosition( position => {
				var { latitude, longitude } = position.coords;

				geocoder( {
					latlng: [ latitude, longitude ].join( ',' ),
				}, results => {
					var match = find( results, result => result.types.indexOf( 'locality' ) >= 0 ) || results[ 0 ];

					$search.val( match.formatted_address );
					$result.val( match.place_id ).trigger( 'input' );

					if ( $form.hasClass( '-autosubmit' ) ) {
						$form.trigger( 'submit' );
					}
				} )
			} );
		} );

		$form.submit( function() {
			var first = find( predictions.children, { isChecked: true } );
			if ( ! first && predictions.children.length > 0 ) {
				first = predictions.at( 0 );
				$search.val( first.model.get( 'label' ) ).trigger( 'input' );
				$result.val( first.model.id ).trigger( 'input' );
				$( this ).data( 'lastQuery', first.model.get( 'label' ) );
			}
		} );

		$( this ).data( 'lastQuery', this.value );
	} );

	var clock = new Clock( {
		el: '#clock',
	} );

	clock.render();

	var calendar = new Calendar( {
		el: '#calendar',
	} );

	calendar.on( 'update', () => {
		$( '#date_picker' ).submit();
	} );

	calendar.render();

	// =========================
	// ! App Geolocation
	// =========================

	var sessionId = $body.data( 'sessionid' );

	if ( sessionId ) {
		flutterDebug( 'session', sessionId );
		getLocation( sessionId, resp => {
			if ( ! resp.latitude || ! resp.longitude ) {
				return;
			}

			geocoder( {
				latlng: [ resp.latitude, resp.longitude ].join( ',' ),
			}, results => {
				var match = find( results, result => result.types.indexOf( 'locality' ) >= 0 ) || results[ 0 ];

				clientLocation = match;

				flutterDebug( 'location', match );

				session.set( 'origin', match.formatted_address );
				session.set( 'origin_id', match.place_id );
			} )
		} );
	}

	// =========================
	// ! Session Editing
	// =========================

	$editors.on( 'input', function() {
		var filled = 0,
			fillable = 0;

		$( this ).find( 'input' ).each( function() {
			if ( this.type !== 'radio' ) {
				fillable++;
			}
			if ( this.value !== '' ) {
				filled++;
			}
		} );

		fillable = Math.max( fillable, 1 );

		$( this ).find( '.button-confirm' ).attr( 'disabled', filled < fillable );
	} );

	$editors.on( 'showing', function() {
		$( this ).find( 'input' ).each( function() {
			const { name, type } = this;

			var value = session.get( name );

			if ( type === 'radio' || type === 'checkbox' ) {
				this.checked = this.value === value;
			} else {
				this.value = value || '';
			}
		} ).trigger( 'input' );
	} );

	$editors.submit( function( e ) {
		e.preventDefault();

		$( this ).find( 'input' ).each( function() {
			const { name, type, value } = this;
			if ( type === 'radio' || type === 'checkbox' ) {
				if ( this.checked ) {
					session.set( name, value );
				}
			} else {
				session.set( name, value );
			}
		} );
	} );

	$editors.submit( function() {
		$body.addClass( 'navigating-back' );
		history.back();
	} );

	$editors.on( 'change', '.-autosubmit', function() {
		$( this ).parents( 'form' ).submit();
	} );
}
